import { createFileRoute } from "@tanstack/react-router";
import { AdminPricingPage } from "@/components/admin/AdminPricingPage";

export const Route = createFileRoute("/_authenticated/admin/pricing")({
  head: () => ({ meta: [{ title: "Pricing — Admin" }] }),
  component: AdminPricingPage,
});
